import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import './index.scss'
import {PaymentTypeOptions} from "@models/paymentType";
import __i18n from "@intl/__i18n";
import {getFormattedDate} from "../../../../utils";

function NewUsersChart({data, type}) {
  const typeLabel = PaymentTypeOptions.find( opt => opt.value === type)["label"]
  
  return (
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column'
          },
          title: {
            useHTML: true,
            text: '<div style="line-height: 20px;text-align: center;"><p>' + __i18n("Payment Report") + '</p><p>' + typeLabel + '</p></div>'
          },
          subtitle: {
            text: ""
          },
          xAxis: {
            type: 'category',
            labels: {
              formatter: function () {
                return getFormattedDate({date : this.value, showTime: false})
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: __i18n("Total Amount")
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: __i18n("Total Amount"),
            data: data.map(item => [item.date_time, item.sum_amount]),
          }]
        }}
      />
    </div>
  )
}

export default injectIntl(NewUsersChart);

